module.exports = __webpack_public_path__ + "assets/img/success.413b52dc.svg";